import { memo } from 'react';
import Box from '@mui/material/Box';
import { Opacity } from '@mui/icons-material';

/**
 * The FuseSplashScreen component is responsible for rendering a splash screen with a logo and a loading spinner.
 * It uses various MUI components to render the logo and spinner.
 * The component is memoized to prevent unnecessary re-renders.
 */
function FuseSplashScreen() {
	return (
		<div id="fuse-splash-screen" style={{'opacity': 0.4}}>
			<div className="logo">
				<img
					className="rounded-3xl"
					width="128"
					src="assets/icon/apple-touch-icon-60x60.png"
					alt="logo"
				/>
			</div>
			<Box
				id="spinner"
				sx={{
					'& > div': {
						backgroundColor: 'palette.secondary.main'
					}
				}}
			>
				<div className="bounce1" />
				<div className="bounce2" />
				<div className="bounce3" />
			</Box>
		</div>
	);
}

export default memo(FuseSplashScreen);
